import styled from "styled-components";
import { COLORS } from "../../../../constants/Styles";

export const HistoryContainer = styled.div`
  max-width: 100vw;
  width: 100%;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  align-items: center;
`;

export const NoHistory = styled.div`
  color: ${COLORS.secondaryLight};
  text-align: center;
`;

export const To = styled.span`
  color: ${COLORS.secondaryLight};
`;

export const FiltersContainer = styled.form`
  display: flex;
  gap: 1rem;
  align-items: center;

  input {
    flex: 1;
    min-width: 350px;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
